import { createResourceBuilder } from '../resource';
import { EResourceMethod } from '../models/IPermission';
import { orgIdParam } from './builderHelper';

export const userDownloadsResources = {
  listDownloads: createResourceBuilder('/downloads/organization/:organization_id', EResourceMethod.Get, orgIdParam()),
  getEngineContent: createResourceBuilder(
    '/downloads/organization/:organization_id/content',
    EResourceMethod.Get,
    orgIdParam()
  ),
  getExamples: createResourceBuilder(
    '/downloads/organization/:organization_id/examples',
    EResourceMethod.Get,
    orgIdParam()
  ),
  getTools: createResourceBuilder('/downloads/organization/:organization_id/tools', EResourceMethod.Get, orgIdParam()),
  getLens: createResourceBuilder('/downloads/organization/:organization_id/lens', EResourceMethod.Get, orgIdParam()),
  getFile: createResourceBuilder('/downloads/get', EResourceMethod.Get),
} as const;
